import React, { FC } from 'react';
import { Icon, IconNames } from '@endpoint/blockparty';

interface AccordionIconProps {
  name?: IconNames;
  isExpanded: boolean;
}

export const AccordionIcon: FC<AccordionIconProps> = ({ isExpanded = false, name = 'ArrowChevronDown', ...props }) => (
  <Icon
    aria-hidden
    color="carbon600"
    name={name}
    role="presentation"
    size="large"
    transform={isExpanded ? 'rotate(-180deg)' : null}
    transformOrigin="center"
    transition="fast"
    transitionProperty="transform"
    {...props}
  />
);

AccordionIcon.displayName = 'AccordionIcon';
